import React, { useLayoutEffect, useRef } from "react";

import styled from "styled-components/macro";

import Portal from "Utilities/PortalMaker";

export const MeasureComponent = ({
  children,
  measurements,
  setMeasurements,
  forceWidthWrapper,
  forceWidth,
}) => {
  const measuringRef = useRef();

  useLayoutEffect(() => {
    if (
      measurements ||
      !(setMeasurements && measuringRef.current instanceof HTMLElement)
    )
      return;

    const { width, height } = measuringRef.current.getBoundingClientRect();

    setMeasurements({ width, height });
  }, [measurements, setMeasurements]);

  if (!measurements && setMeasurements) {
    if (forceWidthWrapper && forceWidthWrapper.current instanceof HTMLElement) {
      forceWidth = forceWidthWrapper.current.getBoundingClientRect().width;
    }

    return (
      <Portal to={document.querySelector("#FnrMeasurements")}>
        <MeasuringContainer ref={measuringRef} style={{ width: forceWidth }}>
          {children}
        </MeasuringContainer>
      </Portal>
    );
  }

  return children;
};

const MeasuringContainer = styled.div`
  & > * {
    position: relative !important;
  }
`;

export default MeasureComponent;
MeasureComponent.displayName = "MeasureComponent";
